import PaginatedProducts from "@/components/Frontend/Products/PaginatedProducts";
import { URLS } from "@/utils/urls";
import { NextPage } from "next";

interface Props {}

const NewArrivals: NextPage<Props> = () => {
  const newArrivalsUrl = URLS?.newArrivalsUrl;

  return <PaginatedProducts url={newArrivalsUrl} title="New Arrivals" />;
};

export default NewArrivals;
